import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { Loader } from 'lucide-react';

export function OpenAITest() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState<string>('');

  const testOpenAI = async () => {
    setStatus('loading');
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error('Not authenticated');

      const response = await fetch(
        `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/verify-openai`,
        {
          headers: {
            'Authorization': `Bearer ${session.access_token}`,
          },
        }
      );

      const data = await response.json();
      
      if (!data.success) {
        throw new Error(data.error || 'Failed to verify OpenAI');
      }

      setStatus('success');
      setMessage(data.message);
    } catch (err) {
      setStatus('error');
      setMessage(err instanceof Error ? err.message : 'An error occurred');
    }
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-sm">
      <h2 className="text-xl font-semibold mb-4">OpenAI Connection Test</h2>
      
      <button
        onClick={testOpenAI}
        disabled={status === 'loading'}
        className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-50"
      >
        {status === 'loading' ? (
          <span className="flex items-center">
            <Loader className="w-4 h-4 animate-spin mr-2" />
            Testing...
          </span>
        ) : (
          'Test OpenAI Connection'
        )}
      </button>

      {message && (
        <div className={`mt-4 p-4 rounded-md ${
          status === 'success' ? 'bg-green-50 text-green-700' : 
          status === 'error' ? 'bg-red-50 text-red-700' : ''
        }`}>
          {message}
        </div>
      )}
    </div>
  );
}